<template>
    <ModalWrapper v-model="isShowModal" :max-width="400">
        <template v-slot:title>{{ $t('report_issue_modal_title') }}</template>
        <template v-slot:content>
            <div class="d-flex flex-column ga-2">
                <v-btn
                    color="primary"
                    variant="tonal"
                    size="large"
                    data-cy="report-issue-system-error"
                    @click="selectType('systemError')"
                >
                    {{ $t('report_issue_types.system_error') }}
                </v-btn>
                <v-btn
                    color="primary"
                    variant="tonal"
                    size="large"
                    data-cy="report-issue-question"
                    @click="selectType('question')"
                >
                    {{ $t('report_issue_types.question') }}
                </v-btn>
                <v-btn
                    color="primary"
                    variant="tonal"
                    size="large"
                    data-cy="report-issue-change-request"
                    @click="selectType('changeRequest')"
                >
                    {{ $t('report_issue_types.change_request') }}
                </v-btn>
            </div>
        </template>
    </ModalWrapper>
</template>

<script setup lang="ts">
    type ReportIssueRequestType = 'systemError' | 'question' | 'changeRequest'

    const emit = defineEmits<{
        select: [requestType: ReportIssueRequestType]
    }>()

    const isShowModal = defineModel<boolean>()

    function selectType(requestType: ReportIssueRequestType) {
        emit('select', requestType)
        isShowModal.value = false
    }
</script>
